import { cn } from './cn';

type BackgroundConfig = { desktop?: string; mobile?: string };

export const withBackgroundColor = (config?: BackgroundConfig, withWings?: boolean) => {
  const { desktop, mobile } = config ?? {};

  if (!desktop && !mobile) {
    return null;
  }

  // Dynamic class names used here should be added to the `safelist` in tailwind config

  return cn('bg', {
    [`${mobile}`]: mobile,
    [`wings ${mobile?.replace('bg', 'wings')}`]: mobile && withWings,
    [`sm:${desktop}`]: desktop,
    [`sm:wings sm:${desktop?.replace('bg', 'wings')}`]: desktop && withWings,
  });
};

export const withTextAlign = (textAlign: 'left' | 'center' | 'right') => {
  if (textAlign === 'left') {
    return 'text-left';
  }
  if (textAlign === 'center') {
    return 'text-center';
  }
  if (textAlign === 'right') {
    return 'text-right';
  }

  return null;
};
